import type { SearchClient } from 'algoliasearch';
import type { InstantSearchOptions } from 'instantsearch.js';

import { useSearchPageData } from 'src/app/pages/search/pageContext';
import { useInstantSearchIndexName, useSearchClient } from 'src/app/pages/search/shared/hooks';

import { useRouting } from './hooks/useRouting';

type Result = ModelHookResult<{
	instantSearchIndexName: string;
	searchClient: SearchClient;
	routing: InstantSearchOptions['routing'];
	isUnderMaintenance: boolean;
}>;

export function useLayout(): Result {
	const {
		data: { searchClient },
	} = useSearchClient();

	const {
		data: { routing },
	} = useRouting();

	const {
		data: { instantSearchIndexName },
	} = useInstantSearchIndexName();

	const {
		data: { featureConfigs },
	} = useSearchPageData();
	const { isUnderMaintenance } = featureConfigs;

	return {
		data: {
			instantSearchIndexName,
			searchClient,
			routing,
			isUnderMaintenance,
		},
	};
}
